import React from 'react';
import { RiInboxUnarchiveLine, RiArrowGoBackLine } from 'react-icons/ri';
import { useAppLevel } from './AppTopbar';
import { useAppConfig } from '../../context/ConfigContext';
import KitsuMark from '../brand/KitsuMark';

/* ══════════════════════════════════════════════════════════════
   NOTHING HERE FOR THIS LEVEL

   A level with no content is an ordinary, expected state — you switch
   to N4 the day you make it live and before you have written all of
   it. The flashcards page used to render this as an ErrorMsg, so an
   empty deck looked like the app had broken.

   It also offers the way out, because a learner who lands here has no
   obvious next move: the level picker is a dropdown in the corner they
   may not connect to what they are seeing.
══════════════════════════════════════════════════════════════ */

export default function LevelEmpty({ kind = 'content', hint }) {
  const { level, setLevel } = useAppLevel();
  const { config } = useAppConfig();

  /* Somewhere to send them: the first other live level, preferring N5
     since that is where the course actually begins. */
  const fallback = ['N5', 'N4', 'N3', 'N2', 'N1']
    .find(l => l !== level && config.levels?.[l] !== false);

  return (
    <div className="ks-card lvl-empty">
      {/* Drifting rather than static: nothing here yet, but the app is
          not broken. */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
        <KitsuMark size={58} animation="float" interactive={false} />
      </div>
      <div className="lvl-empty-icon"><RiInboxUnarchiveLine size={26} /></div>
      <h2>No {level} {kind} yet</h2>
      <p>
        {hint || `${level} is live, but its ${kind} hasn't been added yet. Nothing is broken — there is simply nothing here to study at this level.`}
      </p>
      {fallback && (
        <button className="btn-primary" onClick={() => setLevel(fallback)}>
          <RiArrowGoBackLine size={15} /> Switch back to {fallback}
        </button>
      )}
    </div>
  );
}
